import {t} from "i18next";
import * as Yup from "yup";
import {NewPlanItemDatesForm} from "../../../../../types/newPlanItem";

export const initialValues: NewPlanItemDatesForm = {
    auctionDate: null,
    deliveryDate: null
};

export function DatesValidationSchema(
    currentDate: Date
) {
    return Yup.object({
        auctionDate: Yup.date()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
        deliveryDate: Yup.date()
            .typeError(t("validation.required"))
            .required(t("validation.required")),
    })
}
